<div class="container-prestacion">
    <div class="container-prestacion2">
        <app-datos-atencion-request [atencionTipo]="true" [fechaAtencion]="false"></app-datos-atencion-request>
    </div>
</div>

<app-datos-detalle-procedimiento-request-form></app-datos-detalle-procedimiento-request-form>